<template>
    <div>
	    <b-modal id="modal-conflict-validate" :title="$t('title.2')"  :centered="true" @hidden="hiddenModalValidate">
		    <template #modal-header="{ close }">
                <img class="close" src="@/assets/img/close_red.png" @click="close()">
            </template>
            <h4 class="text-center mb-0">{{ messageValidate }}</h4>
            <template #modal-footer>
                <b-button variant="danger" @click="$bvModal.hide('modal-conflict-validate')"> {{$t('modals.modalConfirmPrivate.button')}} </b-button>
            </template>
	    </b-modal>
    </div>
</template>
<script>
    export default {
        name:"modalValidateProposal",
        props:{
            typeResponseEvent: Number,
            messageValidate: String,
            flagTeacher: Boolean
        },
        methods: {
            hiddenModalValidate(){
                if(this.flagTeacher){
                    this.$router.push({name: 'teacher-class-request'});
                }else{
                    switch(this.typeResponseEvent){
                        case 1:
                            this.$router.push({name: 'horario-calendario-clases'});
                            break;
                        case 2:
                            this.$router.push({ name: 'horario-calendario' , params: { id: "public" }}).catch(err => {});
                            break;
                        case 3:
                            this.$router.push({ name: 'horario-calendario' , params: { id: "private" }}).catch(err => {});
                            break;
                        case 4:
                            this.$router.push({ name: 'horario-calendario' , params: { id: "private", flagTabViewCarousel: true }}).catch(err => {});
                            break;
                    }
                }

                this.$router.go();
		    }
        }
    }
</script>